// Copyright (c) 2020 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import { getBasePath } from '../../../shared/services/get-base-path';
import { handleError } from '../../../shared/services/error-handlers';

const basePath = getBasePath();

export async function getOrderPushedOut ( family, transactionStartDate, transactionEndDate ) {

    const endPoint = `${basePath}/orders-pushedOut`;
    let startDate;
    let endDate;
    if ( transactionStartDate !== undefined && transactionStartDate !== null && transactionStartDate !== '' ) {

        startDate = new Date( transactionStartDate ).getTime();

    }
    if ( transactionEndDate !== undefined && transactionEndDate !== null && transactionEndDate !== '' ) {

        endDate = new Date( transactionEndDate ).getTime();

    }

    const payLoad = {
        family,
        transactionStartDate: startDate,
        transactionEndDate: endDate
    };

    const options = {
        body: JSON.stringify( payLoad ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );
        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}
